var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { makeStyles, Dialog, DialogTitle, DialogActions, DialogButton, useLoading } from "../../../index";
import { useUseCase } from "../../../hooks/useUseCase";
import { useTranslation } from "../../../hooks/useTranslation";
import { initialPmlSelectDialogState } from "./PmlAssignmentSelectDialogState";
import { OpenPmlAssignmentSelectDialogUseCase } from "./usecases/OpenPmlAssignmentSelectDialogUseCase";
import { SelectPmlCourseUseCase } from "./usecases/SelectPmlAssignmentUseCase";
import { ClosePmlAssignmentSelectDialogUseCase } from "./usecases/ClosePmlAssignmentSelectDialogUseCase";
import { PmlAssignmentDialogContents } from "./components/PmlAssignmentDialogContents";
import { useAuth } from "../../../hooks/useAuth";
var useStyles = makeStyles(function (theme) { return ({
    root: {},
    actions: {
        position: 'relative',
    },
}); });
/**
 * 情報活用課題選択ダイアログ
 */
export var PmlAssignmentSelectDialog = function (props) {
    var _a, _b;
    var _c = props.defaultPmlCourse, defaultPmlCourse = _c === void 0 ? { id: '' } : _c, kind = props.kind, open = props.open, onCancel = props.onCancel, onSelect = props.onSelect, others = __rest(props, ["defaultPmlCourse", "kind", "open", "onCancel", "onSelect"]);
    var _d = useUseCase(initialPmlSelectDialogState), state = _d.state, usecase = _d.usecase;
    var t = useTranslation().t;
    var user = useAuth().user;
    var _e = useState('ELEMENTARY_SCHOOL'), schoolType = _e[0], setSchoolType = _e[1];
    var classes = useStyles();
    var startLoading = useLoading().startLoading;
    // コース情報の読み込み中にローディングを表示する
    var loadingFunction = useRef(null);
    useEffect(function () {
        if (state.isLoading && (loadingFunction === null || loadingFunction === void 0 ? void 0 : loadingFunction.current) === null) {
            var endLoading = startLoading().endLoading;
            loadingFunction.current = endLoading;
        }
        else if (loadingFunction.current !== null) {
            loadingFunction === null || loadingFunction === void 0 ? void 0 : loadingFunction.current();
            loadingFunction.current = null;
        }
    }, [startLoading, state.isLoading]);
    useEffect(function () {
        open
            ? usecase(new OpenPmlAssignmentSelectDialogUseCase()).execute({ defaultPmlCourse: defaultPmlCourse, kind: kind })
            : usecase(new ClosePmlAssignmentSelectDialogUseCase()).execute();
    }, [open, usecase]);
    useEffect(function () {
        if (user) {
            setSchoolType(user.schoolType);
        }
    }, [user]);
    var handleCancel = useCallback(function () {
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    }, [onCancel]);
    var handleSelect = useCallback(function () {
        if (!state.selectedPmlCourse.course) {
            return;
        }
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(state.selectedPmlCourse.course);
    }, [onSelect, state.selectedPmlCourse.course]);
    var handleSelectCourse = useCallback(function (course) {
        if (course) {
            usecase(new SelectPmlCourseUseCase()).execute(course);
        }
    }, [usecase]);
    return (React.createElement(Dialog, __assign({ className: classes.root, open: open, fullScreen: true }, others),
        React.createElement(DialogTitle, null, kind === 'KEYBOARD' ? t('コースを選ぶ') : t('テーマを選ぶ')),
        React.createElement(PmlAssignmentDialogContents, { courseInfo: state.pmlCourseAssignmentInfo, kind: kind, schoolType: schoolType, selectedCourseId: (_b = (_a = state.selectedPmlCourse.course) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : defaultPmlCourse.id, onSelectCourse: handleSelectCourse }),
        React.createElement(DialogActions, { className: classes.actions },
            React.createElement(DialogButton, { onClick: handleCancel }, t('キャンセル')),
            React.createElement(DialogButton, { fill: true, onClick: handleSelect, disabled: !state.selectedPmlCourseId }, t('選ぶ')))));
};
